import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Router } from "@angular/router";

@Component({
  selector: 'app-terms-and-conditions',
  templateUrl: './terms-and-conditions.component.html',
  styleUrls: ['./terms-and-conditions.component.css']
})
export class TermsAndConditionsComponent implements OnInit {

  @Output() privacyPolicy = new EventEmitter<boolean>();

  constructor(private router:Router) { }

  ngOnInit() {
  }

  goToHome(){
    this.router.navigateByUrl('/questionnaires');
  }

  goToPrivacyPolicy(){
    this.privacyPolicy.emit(true);
  }
}



// WEBPACK FOOTER //
// ./src/app/terms-and-conditions/terms-and-conditions.component.ts